interface QuestionCardProps {
  personaName: string;
  question: string;
}

export const QuestionCard = ({ personaName, question }: QuestionCardProps) => {
  const displayName = personaName.replace(/_/g, ' ');
  return (
    <div className="text-center space-y-4 max-w-2xl mx-auto">
      <p className="text-sm uppercase tracking-widest text-white/60">
        A question from {displayName}
      </p>
      <p className="text-2xl md:text-3xl font-light leading-relaxed text-white">
        {question}
      </p>
    </div>
  );
};
